module.exports = __webpack_public_path__ + "static/media/cogs.b0fd10bd.svg";